<template>
  <div class="action-float-left mx-1">
    <vx-tooltip text="PDF">
      <feather-icon @click="open" :icon="icon" svgClasses="h-5 w-5  hover:text-primary cursor-pointer" />
    </vx-tooltip>
    <vs-popup :title="title" :active.sync="popupActive" id="action-pdf-viewer">
      <vs-tabs v-if="popupActive">
        <vs-tab :label="getName(file)" v-for="(file, index) in files" :key="index">
          <div class="tab-text">
            <iframe :src="getSrc(file)" class="w-full show-pdf" :style="{ height: '70vh' }"></iframe>
          </div>
        </vs-tab>
      </vs-tabs>
    </vs-popup>
  </div>
</template>
<script>
import { BASE_URL } from '@/urls.js'
export default {
  props: {
    title: {
      type: String,
      default: 'Files'
    },
    files: {
      type: Array,
      default: () => []
    },
    icon: {
      type: String,
      default: 'FileTextIcon'
    },
    disabled: {
      type: Boolean,
      default: false
    },

  },
  data() {
    return {
      popupActive: false
    }
  },
  methods: {
    open() {
      if (this.files.length === 0) {
        this.$vs.notify({
          color: 'warning',
          title: 'Attention',
          text: 'Files Not Found'
        })
        return
      }
      this.popupActive = true
    },
    getName(url){
      let arr = url.split('/').reverse()
      return arr[0]
    },
    getSrc(src){
      return BASE_URL + 'storage/' + src
    }
  }
}

</script>
<style>
/* 1366 x 768 */
#action-pdf-viewer>div.vs-popup {
  width: calc(100% - 30px) !important;
}


</style>
